import IndividualServicePanel from 'src/components/IndividualServices/IndividualServicePanel/IndividualServicePanel';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { WebOpsActionCreator, AppointmentActionCreator, AdditionalServicesActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    specData: state.Specs.specs,
    items: state.WebOps.WebOps,
    itemServiceChecked: state.WebOps.checkedWebOps,
    apptOps: state.Appointment.ApptOps,
    specDefaultDept: state.Specs.specs !== undefined ? state.Specs.specs.departmentFlag : '',
    recom: state.AdditionalServices.allServices.recom,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    apptVeh: state.Appointment.ApptVeh,
    sessionId: state.Framework.sessionId,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
});

const mapDispatchToProps = {
    toggleItem: WebOpsActionCreator.ToggleItems,
    UpdateApptOps: AppointmentActionCreator.UpdateApptOps,
    determineDept: AppointmentActionCreator.DetermineDept,
    toggleRecommended: AdditionalServicesActionCreator.ToggleRecommended,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(IndividualServicePanel);